import React from 'react';
import { Box } from '@chakra-ui/react';
import ContactForm from './ContactForm';
import Information from './Information';
import useBackgroundImage from './Information/useBackgroundImage';
import CenteredFlex from '@components/Shared/CenteredFlex';
import SEO from '@components/SEO';
import { MAIN_URL } from '@src/commons/constants';
import {
  CONTACT_ME_PAGE_DESC,
  CONTACT_ME_PAGE_TITLE,
} from '@src/commons/seoConstants';

const Contact: ComponentWithDataHooks = () => {
  const imageUrl = useBackgroundImage();
  return (
    <>
      <SEO
        title={CONTACT_ME_PAGE_TITLE}
        description={CONTACT_ME_PAGE_DESC}
        url={`${MAIN_URL}/contact`}
        image={imageUrl}
      />
      <CenteredFlex direction="column" w="100%" h="100%">
        <Box
          position="absolute"
          left={0}
          top={0}
          width="100%"
          height="calc(100% + 20px)"
          opacity={0.08}
          backgroundImage={`url('${imageUrl}')`}
          backgroundRepeat="no-repeat"
          backgroundPosition="50% 70%"
          backgroundSize="cover"
        />
        <Information />
        <ContactForm />
      </CenteredFlex>
    </>
  );
};

Contact.dataHooks = [useBackgroundImage];

export default Contact;
